import React, { Component } from 'react';
import Bill_Header from './Bill_Header';

export default class Bill_Page extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				{/* Price table */}
				<div style={{ pageBreakAfter: 'always', breakAfter: 'always' }}>
					<div id="price_bill" className="bill-page">
						{/* Bill Header Image */}
						{this.props.header_img.data != null ?
							<img id="bill_header_image" src={this.props.header_img.data} style={{ maxHeight: '10%', maxWidth: '95%', marginLeft: 20 }} />
							: null}

						<Bill_Header
							receiver={this.props.receiver}
							tenant_name={this.props.tenant_name}
							from_date={this.props.from_date}
							to_date={this.props.to_date}
						/>

						{/* Total Amount */}
						<div className="total-amount-content">
							<div style={{ borderBottom: 'black', borderBottomWidth: '1px', borderBottomStyle: 'solid', display: 'inline-block' }}>
								<span className="text">{this.props.receiver.getString('ppd_total')}</span>
								<span className="text">: </span>
								<span className="amount">{this.props.price_info.currency}</span>
								<span className="amount">{this.props.total_data_info[this.props.tenant_name] == null ? 0 : this.props.total_data_info[this.props.tenant_name].total_price}</span>
							</div>
						</div>

						{/* Table */}
						<table className='bill-table'>
							{/* Headers */}
							<thead>
								<tr>
									<th className="table-header">{this.props.receiver.getString("timezone")}</th>
									<th className="table-header">{this.props.receiver.getString("power_consumption") + '[kWh]'}</th>
									<th className="table-header">{this.props.receiver.getString("unit_price") + '[' + this.props.price_info.currency + ']'}</th>
									<th className="table-header">{this.props.receiver.getString("price") + '[' + this.props.price_info.currency + ']'}</th>
								</tr>
							</thead>
							<tbody>
								{/* Returns each zone information for weekday */}
								{Object.keys(this.props.price_info.zone.weekday).map((zone) => {
									if (this.props.price_info.zone.weekday[zone].enable) {
										let zone_name = this.props.price_info.zone.weekday[zone].name;
										let unit_price = this.props.price_info.zone.weekday[zone].price[0];
										let power_consumption = 0;
										let price = 0;
										if (this.props.bill_data.bill != null) {
											power_consumption = this.props.bill_data.bill[this.props.tenant_name].weekday[zone][0];
											price = this.props.bill_data.bill[this.props.tenant_name].weekday[zone][3];
										}

										return (
											<tr>
												<td className="table-body">{this.props.receiver.getString("weekday") + "\n" + zone_name}</td>
												<td className="table-body" style={{ textAlign: 'right' }}>{power_consumption}</td>
												<td className="table-body" style={{ textAlign: 'right' }}>{unit_price}</td>
												<td className="table-body" style={{ textAlign: 'right' }}>{price}</td>
											</tr>
										)
									} else {
										return null;
									}
								})}

								{/* Returns each zone information for holidays */}
								{Object.keys(this.props.price_info.zone.holiday).map((zone) => {
									if (this.props.price_info.zone.holiday[zone].enable) {
										let zone_name = this.props.price_info.zone.holiday[zone].name;
										let unit_price = this.props.price_info.zone.holiday[zone].price[0];
										let power_consumption = 0;
										let price = 0;
										if (this.props.bill_data.bill != null) {
											power_consumption = this.props.bill_data.bill[this.props.tenant_name].holiday[zone][0];
											price = this.props.bill_data.bill[this.props.tenant_name].holiday[zone][3];
										}

										return (
											<tr>
												<td className="table-body">{this.props.receiver.getString("holiday") + "\n" + zone_name}</td>
												<td className="table-body" style={{ textAlign: 'right' }}>{power_consumption}</td>
												<td className="table-body" style={{ textAlign: 'right' }}>{unit_price}</td>
												<td className="table-body" style={{ textAlign: 'right' }}>{price}</td>
											</tr>
										)
									} else {
										return null;
									}
								})}

								<tr>
									<td className="table-body">{this.props.receiver.getString("ppd_total")}</td>
									<td className="table-body" style={{ textAlign: 'right' }}>{this.props.total_data_info[this.props.tenant_name] == null ? 0 : this.props.total_data_info[this.props.tenant_name].total_power_consumption}</td>
									<td className="table-body" style={{ textAlign: 'right' }}></td>
									<td className="table-body" style={{ textAlign: 'right' }}>{this.props.total_data_info[this.props.tenant_name] == null ? 0 : this.props.total_data_info[this.props.tenant_name].total_price}</td>
								</tr>
							</tbody>
						</table>

						{/* Owner Information */}
						<div style={{ marginTop: 20, textAlign: 'end', paddingRight: 30 }}>
							<span class="owner_name">{this.props.owner_info.name}</span>
							<span class="owner_info">{this.props.owner_info.addr1}</span>
							<span class="owner_info">{this.props.owner_info.addr2}</span>
							<span class="owner_info">{this.props.owner_info.postalcode}</span>
							<span class="owner_info">{this.props.owner_info.contact}</span>
							<span class="owner_info">{this.props.owner_info.tel}</span>
							<span class="owner_info">{this.props.owner_info.email}</span>
						</div>

					</div>
				</div>
			</div>
		)
	}
}